<template>
    <div id="siteHeader" :class=" (mobileMenuOpen ? 'open' : '') + ' ' + headerSize ">
        <div class="brand">
            <svg class="holder" width="380" height="202" viewBox="0 0 380 202" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M250.851 193.7C285.651 184.1 317.651 165.2 341.151 137.8C393.251 77.0999 395.851 -29.0001 329.751 -80.9001C268.051 -129.4 170.551 -119 128.151 -50.4001C104.951 -12.8001 83.851 23.8999 34.751 26.0999C24.751 26.4999 14.651 25.4999 4.65098 26.5999C-49.949 32.6999 4.95097 95.7999 20.651 114.3C56.351 156.3 105.551 187.9 160.151 197.9C190.151 203.4 221.451 201.8 250.851 193.7Z" fill="url(#logo-header-gradient)"/>
                <defs>
                <linearGradient id="logo-header-gradient" x1="180.515" y1="197.876" x2="180.515" y2="-110.891" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#FFFFFF"/>
                    <stop offset="1" stop-color="#FFFFFF"/>
                </linearGradient>
                </defs>
            </svg>
            <div class="image" @click="() => { router.push({ name: 'homepage' }) }">
                <img :src="require('/public/assets/logo-header.svg')" />
            </div>
        </div>

        <div class="menu" v-if="is_authenticated()">
            <div class="menu--content">

                <div class="menu--phone mr-2">
                    <div class="menu--phone--label">
                        <div>
                            Come
                            <br>
                            funziona?
                        </div>
                        <div
                            class="menu--phone--icon"
                            v-b-popover.hover.bottom="'Dubbi sul processo di prenotazione? Chiamaci dal lunedì al venerdì, dalle 10 alle 18'"
                            v-html="info"
                        ></div>
                    </div>
                    <div class="menu--phone--input">
                        <div class="form-control">
                            <a :href="'phone:'+config.site.phoneNumber">
                                <span class="icon" v-html="svg_contacts_phone"></span> {{ config.site.phoneNumber }}
                            </a>
                        </div>
                    </div>
                </div>
                
                <div class="menu--search">
                    <div class="menu--search--label">
                        <div>
                            Cerca un viaggio
                            <br>
                            col codice prodotto
                        </div>
                        <div
                            class="menu--search--icon"
                            v-b-popover.hover.bottom="'Controlla l\'email di notifica della pubblicazione che ti abbiamo inviato'"
                            v-html="info"
                        ></div>
                    </div>
                    <b-input-group class="menu--search--input">
                        <b-form-input
                            ref="menu--search--input"
                            id="menu--search--input"
                            type="text"
                            placeholder="es: BPLTTWSLH"
                            v-model="menu_search_input"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button 
                                variant="cta"
                                @click="() => {
                                    custom_event('searchProductCode', menu_search_input)
                                    router.push({ name: 'detail', params: { travel_id: menu_search_input } })
                                }"
                                :disabled="menu_search_input.length < 9"
                            >
                                Cerca
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                
                <div class="menu--navigation">
                    <navigation />
                </div>

                <div class="menu--user">
                    <user />
                </div>

                <div class="menu--secondaryLogo"></div>
            </div>
        </div>
        <div class="toggle" @click="toggleMenu">
            <div v-html="hamburger"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Navigation from '@/components/header/navigation'
    import User from '@/components/header/user'
    import Router from '@/router'
    import { is_authenticated, custom_event } from '@/utilities'
    import { hamburger, info } from '@/components/svg/common'
    import { svg_contacts_phone } from '@/components/svg/static-pages'

    export default {
        name: 'siteHeader',
        components: {
            'navigation': Navigation,
            'user': User,
        },
        created()
        {
            this.router = Router
            this.hamburger = hamburger
            this.info = info
            this.is_authenticated = is_authenticated
            this.custom_event = custom_event
            this.svg_contacts_phone = svg_contacts_phone
        },
        computed:
        {
        },
        watch: {
            '$route.name': function()
            {
                this.setupHeaderGui()
            }
        },
        data() {
            return {
                headerSize: '',
                menu_search_input: '',
                mobileMenuOpen: false,
                config: Vue.prototype.$config,
            }
        },
        methods:
        {
            setupHeaderGui()
            {
                this.mobileMenuOpen = false
                this.headerSize = 'large'
            },
            toggleMenu()
            {
                this.mobileMenuOpen = !this.mobileMenuOpen
                if(this.mobileMenuOpen)
                {
                    document.body.classList.add('menuOpen')
                }
                else
                {
                    document.body.classList.remove('menuOpen')
                }
            },
        },
        mounted()
        {
            this.setupHeaderGui()
            this.is_authenticated()
        }
    }
</script>

<style lang="scss">
    #siteHeader
    {
        $header-position: absolute;
        width:100%;
        height:$page-header-mobile-height;
        position:$header-position;
        top:0;
        z-index: 999;
        display: flex;
        justify-content: space-between;

        .brand
        {
            height:1px;
            width:220px;
            position:relative;
            z-index: 1;
            .holder
            {
                position:relative;
                width: 100%;
                min-width:380px;
                height: auto;
                top:-50px;
                left:-20px;
                @include customize-gradient(svg);
            }
            .image, .image *
            {
                cursor:pointer;
                margin:0 auto;
                text-align:center;
                display:block;
            }
            img
            {
                max-height: 100%;
                width:auto;
                margin:0 auto;
            }

            .image
            {
                position:relative;
                z-index: 1;
                width: 70%;
                height:auto;
                top:0;
                transform:translateY(20px);
            }

            @include media-breakpoint-up(lg)
            {
                max-width:400px;//width:400px;
                position:absolute;
                left:0;
                top:0;
                width:auto;
                height:auto;

                .image
                {
                    position: absolute;
                    width: 58%;
                    top: 22%;
                    bottom: auto;
                    transform: none;
                    left: 0;
                    right: 0;
                    margin: auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;     
                    a
                    {
                        display:block;
                        width:100%;
                    }
                    img
                    {
                        width:auto;
                        height:auto;
                        max-width:100%;
                        max-height:100%;
                    }
                }

                .holder
                {
                    position:relative;
                }
            }


            @include media-breakpoint-down(md)
            {
              svg{
                display: none;
              }
            }

        }

        .menu
        {
            display:none;
            opacity:0;
            transition:all 1s ease-in-out;
            position:$header-position;
            height:100vh;
            width:100vw;
            background:#fff;
            top:0;
            left:0;

            &--content
            {
                height:100%;
                width:100%;
                padding:$grid-gutter-width/4 $grid-gutter-width/2;
                display:flex;
                flex-direction: column;
                align-items: center;
                justify-content:center;
            }

            &--secondaryLogo
            {
                //order:30;
                margin-bottom:40px;
                background:$white;
                @include customize-gradient(vertical);
            }

            &--navigation
            {
                //order:10;
                margin-bottom:20px;
            }

            &--user
            {
                //order:20;
                margin-bottom:10px;
            }

            &--lite
            {
                margin-bottom:30px;
                text-align: center;
                *
                {
                    color:$liteRed;
                }
            }

            @include media-breakpoint-up(lg)
            {
                display:flex;
                opacity:1;
                height:auto;
                &--content
                {
                    justify-content: flex-end;
                    padding:50px $grid-gutter-width 0 0;
                }
            }
        }

        .toggle
        {
            position:absolute;
            z-index: 1;
            width:32px;
            height:32px;
            top:0;
            right:0;
            margin:$grid-gutter-width/4 $grid-gutter-width/2;
            path
            {
                transition:$transition-base;
                //@include customize-fill("light");
                fill:$white;
                &:nth-child(1) {
                }
                &:nth-child(2) {
                }
                &:nth-child(3) {
                }
            }

            @include media-breakpoint-up(lg)
            {
                display: none;
            }
        }

        @include media-breakpoint-up(lg)
        {
            width:auto;

            .brand
            {
                position:$header-position;
                transition:$transition-base;
                transition-delay:0.35s;
            }

            &.large
            {
                position:$header-position;
            }
            &:not(.large)
            {
                height:auto;
                //background-color:$white;

                .menu--item,
                .integration--item.content,
                .navigation-links
                {
                    //box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.25);
                }
                //box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.25);               

                .brand
                {
                    svg
                    {
                        display:none;
                    }
                    .image
                    {
                        transform:none;
                    }
                    img
                    {
                        width:auto;
                        height: 60px;
                        max-height: 100%;
                        margin:$grid-gutter-width/2 0;
                    }
                }
            }
            .menu
            {
                background:transparent;

                &--item
                {
                    box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
                    height:60px;
                    display: flex;
                    align-items: center;
                    padding:$grid-gutter-width/2 $border-radius-lg/3;
                    margin-left:$grid-gutter-width;
                    border-radius: $border-radius-lg;
                }

                &--content
                {
                    flex-direction: row;
                    align-items: center;
                }

                &--secondaryLogo
                {
                    @extend .menu--item !optional;
                    //order:10;
                    margin-bottom:0;
                    //width:180px;

                    //@include theme-gradient-brand();


                    margin-right: -$grid-gutter-width;
                    padding-left: 80px;
                    border-radius: 45px;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    height:90px;
                    width:auto;

                    padding-bottom:0;
                    padding-top:0;
                }

                &--navigation
                {
                    @extend .menu--item !optional;
                    //order:20;
                    margin-bottom:0;
                    background:$white;
                }

                &--user
                {
                    @extend .menu--item !optional;
                    //order:30;
                    margin-bottom:0;
                    margin-right: -130px;
                    z-index: 1;
                    background:$white;
                    margin-left: 32px;
                }

                &--lite
                {
                    margin:0 0 0 32px;
                    font-size:28px;
                    svg
                    {
                        transition:$transition-base;
                    }
                    &:hover
                    {
                        svg
                        {
                            transform:scale(1.2);
                        }
                    }
                }

            }

            //transizione per quando la pagina scrolla
            .menu--content,
            .holder,
            .image
            {
                transition:all 0.5s ease-in-out;
            }

        }

        .toggler
        {
            margin-left:20px;
            cursor:pointer;
        }

    }

    #siteHeader.open
    {
        .menu
        {
            display:block;
            opacity: 1;
            //z-index:1;
        }
        .brand
        {
            //z-index:2;
        }
        .toggle path
        {
            //@include customize-fill("dark");
            
            &:nth-child(2) {opacity:0;}

            &:nth-child(1) {
                transform:rotate(45deg) translateY(-24px) translateX(13px);
            }
            &:nth-child(3) {
                transform:rotate(-45deg) translateY(-7px) translateX(-24px);
            }
        }
    }

    body.menuOpen
    {
        @include media-breakpoint-down(md)
        {
            overflow: hidden;
        }
    }

    /*
    body.scrolling
    {
    }
    */

    .menu--search,
    .menu--phone
    {
        display:flex;
        flex-wrap: wrap;
        align-items: center;
        &--label
        {
            margin:0 1rem;
            font-weight:bold;
            line-height: 120%;
            @include media-breakpoint-up(md)
            {
                text-align: right;
                //max-width: 240px;
                font-size: 12px;
                //white-space:nowrap;
                background:$white;
                height:50px;
                border-radius: $border-radius-lg;
                display: flex;
                align-items: center;
                padding:0 60px 0 26px;
                margin:0;
                margin-right:-40px;
            }
        }
        &--icon
        {
            margin-left:10px;
            svg path
            {
                fill:$text;
            }
        }
        .form-control
        {
            width:auto;
            border-radius: $border-radius-lg;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-top:0;
            border-bottom:0;
            border-right:0;
            a,
            a *
            {
                color:$text !important;
                text-decoration: none;
            }
            .icon
            {
                display: inline-block;
                width:16px;
                margin-right:6px;
                margin-left:-12px;
                svg
                {
                    max-width: 100%;
                    height:auto;
                }
            }
        }
        .btn
        {
            height:100%;
            padding:0 20px 0 16px;
            font-size:12px;
        }
        &--input.input-group
        {
            width:auto;
        }
    }
</style>